import React from "react";
import { SoonBadge, SOON_TOOLTIP } from "../SoonBadge";
import { Tooltip } from "../Tooltip";
import { TabButton } from "./CategoryTab.styles";
import type { CategoryTabProps } from "./CategoryTab.types";

export const CategoryTab: React.FC<CategoryTabProps> = ({
  label,
  isActive,
  onClick,
  count,
  soon = false,
  className,
}) =>
  soon ? (
    <Tooltip label={SOON_TOOLTIP}>
      <TabButton type="button" role="tab" aria-selected={false} aria-disabled="true" tabIndex={-1} $isActive={false} className={className}>
        {label}
        <SoonBadge />
      </TabButton>
    </Tooltip>
  ) : (
  <TabButton
    type="button"
    $isActive={isActive}
    onClick={onClick}
    role="tab"
    aria-selected={isActive}
    className={className}
  >
    {label}
    {typeof count === "number" ? ` (${count})` : null}
  </TabButton>
  );

export default CategoryTab;
